import React from "react";

export default function CommunicationSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M2.9697 10.6667L0 13V0.666667C0 0.29848 0.29848 0 0.666667 0H12.6667C13.0349 0 13.3333 0.29848 13.3333 0.666667V10C13.3333 10.3682 13.0349 10.6667 12.6667 10.6667H2.9697ZM2.50855 9.33333H12V1.33333H1.33333V10.2567L2.50855 9.33333ZM6 4.66667H7.33333V6H6V4.66667ZM3.33333 4.66667H4.66667V6H3.33333V4.66667ZM8.66667 4.66667H10V6H8.66667V4.66667Z"
        fill="#9CA3AF"
      />
    </svg>
  );
}
